import React from 'react';

import { Grid } from '@material-ui/core';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledTypography, FlexContainer, StyledTooltip } from 'styles/common';

import { ANSWER_TYPES, QUESTION_TYPES } from 'constants/ProjectConstants';

import { showQuestionDetails } from 'services/questionDetails';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';

import QuestionMenuOptions from './questionMenuOptions';
import { TabularGrid, PaddedGrid } from './styles';

export const HoverOptionItems = styled(FlexContainer)`
  justify-content: flex-end;
  visibility: hidden;
`;

const QuestionRow = ({ source, question, rowClickable, menuOptions, updateData, competencies, drivers }) => {
  const answerTypes = ANSWER_TYPES[source];
  const questionTypes = QUESTION_TYPES[source];
  const dispatch = useDispatch();
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const history = useHistory();

  const getLabel = (data, value, labelKey = 'label', valueKey = 'value') => {
    try {
      const resp = data.filter((d) => d[valueKey] === value)[0];
      if (resp[valueKey] === 'COMPETENCY' && question.tagId && competencies) {
        const comp = competencies.filter((c) => c.id === question.tagId)[0];
        if (comp) {
          return `${resp[labelKey]} (${comp.displayName})`;
        }
      }
      return resp[labelKey] === 'Goal' ? moduleName : resp[labelKey];
    } catch (e) {
      return 'Options';
    }
  };

  const handleRowClick = (questionId) => {
    dispatch(showQuestionDetails({ questionId, action: 'edit', source, history }));
  };

  const showThirdColumn = ['review', 'engagement'].includes(source);

  return (
    <TabularGrid container hoverable onClick={() => rowClickable && handleRowClick(question.id)}>
      <PaddedGrid item xs={showThirdColumn ? 6 : 7}>
        <StyledTooltip title={question.description}>
          <StyledTypography truncate color="#333">
            {question.description}
          </StyledTypography>
        </StyledTooltip>
      </PaddedGrid>
      <PaddedGrid item xs={showThirdColumn ? 2 : 3}>
        <StyledTypography color="#333">{getLabel(answerTypes, question.answerType)}</StyledTypography>
      </PaddedGrid>
      {showThirdColumn && (
        <PaddedGrid item xs={3}>
          <StyledTypography color="#333">
            {source === 'review'
              ? getLabel(questionTypes, question.questionType)
              : getLabel(drivers, question.tagId, 'displayName', 'id')}
          </StyledTypography>
        </PaddedGrid>
      )}
      <Grid item xs={showThirdColumn ? 1 : 2}>
        <HoverOptionItems>
          <QuestionMenuOptions question={question} menuOptions={menuOptions} updateData={updateData} source={source} />

          {rowClickable && <CircularOutlineIcon style={{ marginLeft: '1rem' }} color="primary" />}
        </HoverOptionItems>
      </Grid>
    </TabularGrid>
  );
};

export default QuestionRow;
